import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./../styles/ecom.css";
import "./../styles/ecom/carrito.css";
import NavbarTop from "./ecom/Navbartop";
import Footer from "./ecom/Footer";
import * as globals from './../components/GlobalScripts.js';

const Carrito = () => {
    const [carrito, setCarrito] = useState([]);
    const [envioGratis, setEnvioGratis] = useState(false);

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, []);

    useEffect(() => {
        const carritoData = JSON.parse(localStorage.getItem("carrito")) || [];
        setCarrito(carritoData);
        verificarEnvioGratis(carritoData);
    }, []);

    const actualizarCantidad = (index, cantidad) => {
        const nuevoCarrito = [...carrito];
        nuevoCarrito[index].cantidad = cantidad;
        if (nuevoCarrito[index].cantidad < 1) nuevoCarrito[index].cantidad = 1;
        setCarrito(nuevoCarrito);
        localStorage.setItem("carrito", JSON.stringify(nuevoCarrito));
        verificarEnvioGratis(nuevoCarrito);
    };

    const eliminarProducto = (index) => {
        const nuevoCarrito = carrito.filter((_, i) => i !== index);
        setCarrito(nuevoCarrito);
        localStorage.setItem("carrito", JSON.stringify(nuevoCarrito));
        verificarEnvioGratis(nuevoCarrito);
    };

    const verificarEnvioGratis = (carrito) => {
        const total = carrito.reduce((acc, item) => acc + item.precio * item.cantidad, 0);
        const tieneEnvioGratis = carrito.some((item) => item.envio === "gratis");
        if (tieneEnvioGratis || total >= 2000) {
            setEnvioGratis(true);
        } else {
            setEnvioGratis(false);
        }
    };

    const total = carrito.reduce((acc, item) => acc + item.precio * item.cantidad, 0);
    const costoEnvio = envioGratis ? 0 : 200;
    const totalConEnvio = total + costoEnvio;

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-carrito">
                <div className="page-container">
                    <div className="container-section medium-section gap-20 flex-column margin-top">
                        <h1>Tu carrito</h1>
                        {carrito.length > 0 ? (
                            <div className="cart-items">
                                {carrito.map((item, index) => (
                                    <div className="cart-item" key={index}>
                                        <div className="product-info">
                                            <img src={item.imagen} alt={item.nombre} />
                                            <div className="cart-item-details">
                                                <h3>{item.nombre}</h3>
                                                <p>Color: {item.color}</p>
                                                <p>Talla: {item.talla}</p>
                                            </div>
                                        </div>
                                        <div className="cart-item-quantity">
                                            <button
                                                onClick={() => actualizarCantidad(index, item.cantidad - 1)}
                                            >
                                                -
                                            </button>
                                            <input type="text" value={item.cantidad} readOnly />
                                            <button
                                                onClick={() => actualizarCantidad(index, item.cantidad + 1)}
                                            >
                                                +
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => eliminarProducto(index)}
                                            >
                                                <svg viewBox="0 0 82 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.625 6.25C4.9674 6.25 3.37768 6.90848 2.20558 8.08058C1.03348 9.25268 0.375 10.8424 0.375 12.5V18.75C0.375 20.4076 1.03348 21.9973 2.20558 23.1694C3.37768 24.3415 4.9674 25 6.625 25H9.75V81.25C9.75 84.5652 11.067 87.7446 13.4112 90.0888C15.7554 92.433 18.9348 93.75 22.25 93.75H59.75C63.0652 93.75 66.2446 92.433 68.5888 90.0888C70.933 87.7446 72.25 84.5652 72.25 81.25V25H75.375C77.0326 25 78.6223 24.3415 79.7944 23.1694C80.9665 21.9973 81.625 20.4076 81.625 18.75V12.5C81.625 10.8424 80.9665 9.25268 79.7944 8.08058C78.6223 6.90848 77.0326 6.25 75.375 6.25H53.5C53.5 4.5924 52.8415 3.00269 51.6694 1.83058C50.4973 0.65848 48.9076 0 47.25 0L34.75 0C33.0924 0 31.5027 0.65848 30.3306 1.83058C29.1585 3.00269 28.5 4.5924 28.5 6.25H6.625ZM25.375 31.25C26.2038 31.25 26.9987 31.5792 27.5847 32.1653C28.1708 32.7513 28.5 33.5462 28.5 34.375V78.125C28.5 78.9538 28.1708 79.7487 27.5847 80.3347C26.9987 80.9208 26.2038 81.25 25.375 81.25C24.5462 81.25 23.7513 80.9208 23.1653 80.3347C22.5792 79.7487 22.25 78.9538 22.25 78.125V34.375C22.25 33.5462 22.5792 32.7513 23.1653 32.1653C23.7513 31.5792 24.5462 31.25 25.375 31.25ZM41 31.25C41.8288 31.25 42.6237 31.5792 43.2097 32.1653C43.7958 32.7513 44.125 33.5462 44.125 34.375V78.125C44.125 78.9538 43.7958 79.7487 43.2097 80.3347C42.6237 80.9208 41.8288 81.25 41 81.25C40.1712 81.25 39.3763 80.9208 38.7903 80.3347C38.2042 79.7487 37.875 78.9538 37.875 78.125V34.375C37.875 33.5462 38.2042 32.7513 38.7903 32.1653C39.3763 31.5792 40.1712 31.25 41 31.25ZM59.75 34.375V78.125C59.75 78.9538 59.4208 79.7487 58.8347 80.3347C58.2487 80.9208 57.4538 81.25 56.625 81.25C55.7962 81.25 55.0013 80.9208 54.4153 80.3347C53.8292 79.7487 53.5 78.9538 53.5 78.125V34.375C53.5 33.5462 53.8292 32.7513 54.4153 32.1653C55.0013 31.5792 55.7962 31.25 56.625 31.25C57.4538 31.25 58.2487 31.5792 58.8347 32.1653C59.4208 32.7513 59.75 33.5462 59.75 34.375Z" fill="black" />
                                                </svg>
                                            </button>
                                        </div>
                                        <div className="cart-item-total">
                                            ${(item.precio * item.cantidad).toFixed(2)}
                                        </div>
                                    </div>
                                ))}

                                <div className="cart-summary">
                                    {envioGratis ? (
                                        <p className="envio-gratis">Cumples los requisitos para envío gratis.</p>
                                    ) : (
                                        <div className="flex-column gap-5 align-end">
                                            <h3 className="costo-envio">Costo de envío</h3>
                                            <p>$200 MXN</p>
                                            {2000 - total > 0 && (
                                                <p>
                                                    <i style={{ color: 'var(--color-red)' }}>
                                                        Agrega ${Math.max(2000 - total, 0).toFixed(2)} MXN más para envío gratis.
                                                    </i>
                                                </p>
                                            )}
                                        </div>
                                    )}
                                    <h3>Subtotal</h3>
                                    <p>${total.toFixed(2)} MXN</p>
                                    <Link to="/comprar" className="button-primary green">
                                        Finalizar compra
                                    </Link>
                                    <Link to="/" className="continue-shopping">
                                        Continuar comprando
                                    </Link>
                                </div>

                            </div>
                        ) : (
                            <p>
                                Tu carrito está vacío. <Link to="/">Continúa comprando</Link>.
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Carrito;